<template>
  <iframe ref="pdfFrame" style="width: 100%; height: 100vh;padding-top: 10vh">
    <div v-html="htmlContent"></div>
  </iframe>
</template>

<script>
import region from '@/../region.json';

export default {
  data() {
    return {
      htmlContent: '',
    };
  },
  async mounted() {
    try {
      const response = await fetch(`/privacy_qwello-${region.entity}.html`);

      if (!response.ok) {
        // TODO(greg): add a error message
        return;
      }

      const content = await response.text();

      if (content.indexOf('<script') === -1) {
        const iframeDoc = this.$refs.pdfFrame.contentDocument;
        iframeDoc.open();
        iframeDoc.write(content);
        iframeDoc.close();
      }
    } catch (error) {
      // TODO(greg): add a error message
    }
  },
};
</script>
